<template>
  <div class="expand-item-container">
    <div class="expand-item">
      助记码：{{row.mnemonicCode}}
    </div>
    <div class="expand-item">
      商品名称：{{row.goodsName}}
    </div>
    <div class="expand-item">
      批次：{{row.goodsBatchSeq}}
    </div>
    <div class="expand-item">
      供应商：{{row.supplierName}}
    </div>
  </div>

</template>
<script>

export default {
  name: 'CuringReCheckExpand',
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
  },
};
</script>
